import { Loading } from '@/components/ui/daisy';
import { FileTree } from '@/components/ui/daisy/templates/file-tree';
import { REQUEST_STALE_TIME_IN_MS } from '@/constants';
import useCourseTreeNavigate from '@/data/hook/course-line/useCourseTreeNavigate';
import useInfiniteService from '@/data/hook/useInfiniteService';
import { courseLinesQueryKeys } from '@/data/services/querykeys';
import { mountKey } from '@/utils/courses';
import { ROUTES } from '@/utils/routes';
import { scrollBarYClassName } from '@/utils/scrollBarClassName';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';
import CourseLinesTree from '../CourseLinesTree';
import CoursesTreeList from '@/components/shared/CoursesTreeList';
import TreeAddButton from '@/components/shared/TreeAddButton';

export default function CoursesTreeRoot() {
  const { t } = useTranslation('translation', {
    keyPrefix: 'courseLineForm.fileTree',
  });

  const {
    results: courseLines,
    fetchNextPage,
    isInitialLoading,
    hasNextPage,
    isFetchingNextPage,
  } = useInfiniteService({
    ...courseLinesQueryKeys.list()._ctx.infinity,
    staleTime: REQUEST_STALE_TIME_IN_MS,
  });

  const { navigate } = useCourseTreeNavigate();

  const icon = isInitialLoading
    ? {
        custom: <Loading size="xs" color="primary" />,
      }
    : undefined;

  return (
    <div className="relative max-xl:w-72 w-xs rounded-2xl bg-base-100 shadow-default h-fit">
      <FileTree
        className={twMerge('max-h-[calc(100vh-150px)]', scrollBarYClassName)}
        size="md"
      >
        <FileTree.Item label={t('courses')} defaultOpen icon={icon}>
          <CoursesTreeList
            isFetchingNextPage={isFetchingNextPage}
            isLoading={isInitialLoading}
            onReachEnd={fetchNextPage}
            hasNextPage={hasNextPage}
          >
            {courseLines.map(courseLine => (
              <CourseLinesTree
                key={mountKey({ type: 'courseLine', id: courseLine.id })}
                item={courseLine}
                parentId="root"
              />
            ))}
            <TreeAddButton
              label={t('newCourse')}
              onClick={() => navigate(ROUTES.ADMIN.COURSE_LINES.BASE)}
            />
          </CoursesTreeList>
        </FileTree.Item>
      </FileTree>
    </div>
  );
}
